import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { usePortal } from 'hooks/usePortal';

import './style.scss';

const Portal = ({ id, className, onClose, children }) => {
  const target = usePortal(id);

  const handleClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const Component = (
    <div className="modal-wrapper" onClick={handleClick}>
      <div className={`modal ${className}`}>{children}</div>
    </div>
  );

  return createPortal(Component, target);
};

Portal.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

Portal.defaultProps = {
  className: '',
};

export { Portal };
